import { render, staticRenderFns } from "./RFileupload.vue?vue&type=template&id=32327bf2&scoped=true"
import script from "./RFileupload.vue?vue&type=script&lang=js"
export * from "./RFileupload.vue?vue&type=script&lang=js"
import style0 from "./RFileupload.vue?vue&type=style&index=0&id=32327bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32327bf2",
  null
  
)

export default component.exports